import { render, staticRenderFns } from "./MdmIcon.vue?vue&type=template&id=44048dd0&"
import script from "./MdmIcon.vue?vue&type=script&lang=js&"
export * from "./MdmIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports